import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageCircle, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export const WhatsAppStatusCard = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/whatsapp/status").then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s) return null;
  const copy = async () => { await navigator.clipboard.writeText(s.webhook_url); toast.success("Webhook URL copied"); };
  return (
    <div className="rounded-xl border border-border bg-card p-5" data-testid="wa-status-card">
      <h3 className="flex items-center gap-2 font-head text-sm font-semibold"><MessageCircle className="h-4 w-4 text-emerald-500" /> WhatsApp Business (Meta Cloud API)
        <span className={`rounded-full px-2 py-0.5 text-xs ${s.enabled ? "bg-emerald-500/15 text-emerald-500" : "bg-amber-500/15 text-amber-500"}`} data-testid="wa-status-badge">{s.enabled ? "Connected" : "Not connected"}</span></h3>
      <p className="mt-2 text-xs text-muted-foreground">{s.enabled
        ? "Certificate PDFs can be sent directly to a partner within 24 hours of their last WhatsApp message."
        : "Until the WhatsApp Business keys are added, sharing uses the Open WhatsApp link and you attach the PDF yourself."}</p>
      <div className="mt-2 flex flex-wrap items-center gap-2 text-xs">
        <span className="text-muted-foreground">Webhook URL for Meta (subscribe to "messages"):</span>
        <code className="rounded bg-background px-2 py-1 font-mono" data-testid="wa-webhook-url">{s.webhook_url}</code>
        <Button size="sm" variant="ghost" className="h-7" onClick={copy} data-testid="wa-webhook-copy"><Copy className="h-3.5 w-3.5" /></Button>
      </div>
    </div>
  );
};
